<template>
  <b-container>
    <b-row>
      <b-col>
        <h2>{{ uniTranslation("GO001") }}</h2>
      </b-col>
    </b-row>
    <br />
    <b-container>
      <b-row>
        <b-col md="6"></b-col>
        <b-col md="6" class="bordo" style="text-align:left">
          <p>{{ uniTranslation("GO002") }}</p>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row>
        <b-col style="text-align:left">
          <h5>{{ uniTranslation("GO003") }}</h5>
        </b-col>
      </b-row>
      <b-row class="bordo">
        <b-col md="1" class="bordo-dx">
          <input type="checkbox" style="margin-right:15px" disabled="true" checked />
        </b-col>
        <b-col md="9" class="bordo-dx" style="text-align:left">
          <p v-text="uniTranslation(plateExchanger.nome)"></p>
        </b-col>
        <b-col md="2" style="text-align:right">
          <b v-text="simboloValuta + ' ' + plateExchanger.prezzo"></b>
        </b-col>
      </b-row>
    </b-container>
    <br />
    <div>
      <b-row style="padding-left:15px">
        <b-col style="text-align:left">
          <h5>{{ uniTranslation("GO005") }}</h5>
        </b-col>
      </b-row>
      <b-container class="bordo">
        <b-row v-for="item in opzioni" :key="item.nome" class="bordo-sotto">
          <b-col md="1" class="bordo-dx">
            <input
              v-model="item.ckd"
              type="checkbox"
              style="margin-right:15px"
              @click="aggiornaPrezzoAccessori(item)"
            />
          </b-col>
          <b-col md="3" class="bordo-dx" style="text-align:left">
            <p v-text="uniTranslation(item.nome)"></p>
          </b-col>
          <b-col md="6" class="bordo-dx" style="text-align:left">
            <p v-text="item.descrizione"></p>
          </b-col>
          <b-col md="2" style="text-align:right">
            <b v-text="simboloValuta + ' ' + item.prezzo"></b>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <br />
    <b-card no body>
      <b-row style="padding-left:15px">
        <b-col style="text-align:left">
          <h5>{{ uniTranslation("GO010") }}</h5>
        </b-col>
      </b-row>
      <b-card-body
        id="nav-scroller"
        ref="content"
        style="position:relative; height:200px; overflow-y:scroll;"
        class="bordo"
      >
        <b-container>
          <b-row v-for="item in accessori" :key="item.nome" class="bordo-sotto">
            <b-col md="1" class="bordo-dx">
              <input
                v-model="item.ckd"
                type="checkbox"
                style="margin-right:15px"
                @click="aggiornaPrezzoAccessori(item)"
              />
            </b-col>
            <b-col md="9" class="bordo-dx" style="text-align:left">
              <p v-text="uniTranslation(item.nome)"></p>
            </b-col>
            <b-col md="2" style="text-align:right">
              <b v-text="simboloValuta + ' ' + item.prezzo"></b>
            </b-col>
          </b-row>
        </b-container>
      </b-card-body>
    </b-card>
    <br />
    <div>
      <b-row style="padding-left:15px">
        <b-col md="4" style="text-align:left">
          <h5>{{ uniTranslation("GO018") }}</h5>
        </b-col>
        <b-col md="3" style="text-align:right">
          <h5>{{ uniTranslation("GO019") }}</h5>
        </b-col>
        <b-col md="2">
          <h5>{{ uniTranslation("GO020") }}</h5>
        </b-col>
        <b-col md="3" style="text-align:right">
          <h5>{{ uniTranslation("GO021") }}</h5>
        </b-col>
      </b-row>
      <b-container class="bordo">
        <b-row class="bordo-sotto">
          <b-col md="4" class="bordo-dx" style="text-align:left">
            <p>{{ uniTranslation("GO022") }}</p>
          </b-col>
          <b-col md="3" class="bordo-dx" style="text-align:right">
            <p v-text="simboloValuta + ' ' + plateExchanger.prezzo"></p>
          </b-col>
          <b-col md="2" class="bordo-dx">
            <input
              v-model="scontoExchanger"
              value="0"
              style="width:100%;border:none;text-align:center"
              @blur="validaScontoExchanger()"
            />
          </b-col>
          <b-col md="3" style="text-align:right">
            <p
              v-text="
                simboloValuta +
                  ' ' +
                  round((plateExchanger.prezzo / 100) * (100 - scontoExchanger), 2)
              "
            ></p>
          </b-col>
        </b-row>
        <b-row class="bordo-sotto">
          <b-col md="4" class="bordo-dx" style="text-align:left">
            <p>{{ uniTranslation("GO023") }}</p>
          </b-col>
          <b-col md="3" class="bordo-dx" style="text-align:right">
            <p v-text="simboloValuta + ' ' + prezzoAccessori"></p>
          </b-col>
          <b-col md="2" class="bordo-dx">
            <input
              v-model="scontoAccessori"
              value="0"
              style="width:100%;border:none;text-align:center"
              @blur="validaScontoAccessori()"
            />
          </b-col>
          <b-col md="3" style="text-align:right">
            <p
              v-text="
                simboloValuta + ' ' + round((prezzoAccessori / 100) * (100 - scontoAccessori), 2)
              "
            ></p>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4" class="bordo-dx" style="text-align:left">
            <b>{{ uniTranslation("GO024") }}</b>
          </b-col>
          <b-col md="3" class="bordo-dx" style="text-align:right">
            <b v-text="simboloValuta + ' ' + (plateExchanger.prezzo + prezzoAccessori)"></b>
          </b-col>
          <b-col md="2" class="bordo-dx">
            <input
              v-model="scontoTotale"
              value="0"
              style="width:100%;border:none;text-align:center"
              @blur="validaScontoTotale()"
            />
          </b-col>
          <b-col md="3" style="text-align:right">
            <b
              v-text="
                '€ ' +
                  round(((plateExchanger.prezzo + prezzoAccessori) / 100) * (100 - scontoTotale), 2)
              "
            ></b>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <br />
    <div>
      <b-row style="padding-left:15px">
        <b-col style="text-align:left">
          <h5>{{ uniTranslation("GO025") }}</h5>
        </b-col>
      </b-row>
      <b-container class="bordo">
        <b-row class="bordo-sotto">
          <b-col style="text-align:left">
            <input v-model="remarks1" style="width:100%;border:none;text-align:left" />
          </b-col>
        </b-row>
        <b-row class="bordo-sotto">
          <b-col style="text-align:left">
            <input v-model="remarks2" style="width:100%;border:none;text-align:left" />
          </b-col>
        </b-row>
        <b-row class="bordo-sotto">
          <b-col style="text-align:left">
            <input v-model="remarks3" style="width:100%;border:none;text-align:left" />
          </b-col>
        </b-row>
      </b-container>
    </div>
    <br />
    <b-row>
      <b-col md="2">
        <button style="padding:10px 40px">&LT;- {{ uniTranslation("GO026") }}</button>
      </b-col>
      <b-col md="8"></b-col>
      <b-col md="2">
        <button style="padding:10px 40px" @click="invia">&GT;-{{ uniTranslation("GO027") }}</button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import offersService from "../../services/backend/offersService";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      opzioni: [],
      accessori: [],
      plateExchanger: "",
      prezzoAccessori: 0,
      prezzoTotale: 0,
      scontoExchanger: 0,
      scontoAccessori: 0,
      scontoTotale: 0,
      scontoMax: 30,
      remarks1: "",
      remarks2: "",
      remarks3: ""
    };
  },
  computed: {
    ...mapGetters(["simboloValuta"])
  },
  mounted: function() {
    var that = this;
    offersService.getOpzioni().then(function(data) {
      that.opzioni = data;
    });
    offersService.getAccessori().then(function(data) {
      that.accessori = data;
    });
    offersService.getPlateExchanger().then(function(data) {
      that.plateExchanger = data[0];
    });
    that.prezzoAccessori = 0;
    for (let i = 0; i < that.opzioni.length; i++) {
      //opzioni
      let corrente = that.opzioni[i];
      if (corrente.ckd) that.prezzoAccessori += corrente.prezzo;
    }
    for (let i = 0; i < that.accessori.length; i++) {
      // accessori
      let corrente = that.accessori[i];
      if (corrente.ckd) that.prezzoAccessori += corrente.prezzo;
    }
  },
  methods: {
    round: function(valore, posizioniDecimali) {
      var ris = valore * Math.pow(10, posizioniDecimali);
      ris = Math.round(ris);
      return ris / Math.pow(10, posizioniDecimali);
    },
    aggiornaPrezzoAccessori: function(item) {
      if (!item.ckd) this.prezzoAccessori += item.prezzo;
      else this.prezzoAccessori -= item.prezzo;
      this.prezzoAccessori = this.round(this.prezzoAccessori, 2);
    },
    invia() {
      offersService.postOpzioni(this.opzioni);
      offersService.postAccessori(this.accessori);
      offersService.postRemarks({
        riga1: this.remarks1,
        riga2: this.remarks2,
        riga3: this.remarks3
      });
      var sconti = [this.scontoExchanger, this.scontoAccessori, this.scontoTotale];
      offersService.postSconti(sconti);
    },
    validaScontoAccessori() {
      this.scontoAccessori = Math.max(Math.min(this.scontoAccessori, this.scontoMax), 0);
    },
    validaScontoExchanger() {
      this.scontoExchanger = Math.max(Math.min(this.scontoExchanger, this.scontoMax), 0);
    },
    validaScontoTotale() {
      this.scontoTotale = Math.max(Math.min(this.scontoTotale, this.scontoMax), 0);
    }
  }
};
</script>

<style>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

a {
  color: black;
}

.card-header {
  padding: 0px;
  background-color: unset;
}

.card-body {
  padding: 0px;
}

.card {
  border: unset;
}

.bordo-dx {
  border-right: solid;
  border-right-color: #cccccc;
  border-right-width: 1px;
}

.bordo-sotto {
  border-bottom: solid;
  border-bottom-color: #cccccc;
  border-bottom-width: 1px;
}
.om {
  border-bottom: solid;
  border-bottom-color: #cccccc;
  border-bottom-width: 1px;
  padding: 13px 0px;
}
.bordo {
  border: solid;
  border-width: 1px;
}

p {
  margin-bottom: 0rem;
}
</style>
